import {Productstage} from "@k/js/produktController"
import {Store} from "vuex";
import {AuswahlProdukt, Feature, Product, SelectedFeature} from "@k/js/product"
import {Produktresponse, CurrentproductPossibleDesignEntry} from "@k/js/databaseInterfaceClasses"
import {ProduktAuswahlProdukt} from "@km/store/ProduktAuswahlStore";

export class ProductStageWrapperStore implements Productstage {
    private store: Store<any>;

    public constructor(store:Store<any>) {
        this.store = store;
    }

    getModel(): string {
        return this.store.getters.getStagedproductModel;
    }

    getPossibleDesigns(): Array<CurrentproductPossibleDesignEntry> {
        return this.store.getters.getStagedproductPossibleDesigns
    }

    getRealSport(): string {
        return this.store.getters.getStagedproductRealSport
    }

    getproduct(): Product {
        return this.store.getters.getStagedProduct
    }

    setBaseModel(model: string | null): void {
        this.store.commit("SET_STAGED_PRODUCT_BASEMODEL", model)
    }

    stageNewProduct(auswahlProdukt: AuswahlProdukt|ProduktAuswahlProdukt, features: SelectedFeature[], data: Produktresponse) {
        this.store.commit("STAGE_PRODUCT", {auswahlProdukt, features, data})
    }

    useStagedProductAsCurrentProduct(): void {
        this.store.dispatch("useStagedProductAsCurrentProduct");
    }

}